<div class="col-12 px-0 starContainer" (mouseleave)="onMouseLeave($event)" (mousemove)="onMouseOver($event)"
    (click)="onMouseClick($event)">

    <!-- EMPTY -->
    <i class="far fa-star {{isHovered? 'text-white' : 'cm-tx-color-11'}}" *ngIf="state == StarState.empty"></i>
    <!-- HALF -->
    <i class="fas fa-star-half-alt {{isHovered? 'text-white' : 'cm-tx-color-11'}}" *ngIf="state == StarState.half"></i>
    <!-- FULL -->
    <i class="fas fa-star {{isHovered? 'text-white' : 'cm-tx-color-11'}}" *ngIf="state == StarState.full"></i>

</div>